import { keyframes } from '@emotion/react';
export function popoverEnter({ animationDirection }) {
    return keyframes({
        from: {
            opacity: 0,
            transform: `translate(${animationDirection})`,
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)',
        },
    });
}
export const popoverExit = keyframes({
    from: {
        opacity: 1,
        transform: 'translate(0)',
    },
    to: {
        opacity: 0,
        transform: 'translate(0)',
    },
});
